import {
  Meta,
  Links,
  Scripts,
  LiveReload,
  ScrollRestoration,
} from '@remix-run/react';
import type { FC } from 'react';

interface RootDocumentProps {
  children: React.ReactNode;
}

export const RootDocument: FC<RootDocumentProps> = ({ children }) => {
  return (
    <html lang="en" className="dark">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="dark:bg-[#17181A] dark:text-darkMode-gray-light">
        {children}
        <div id="portal" />
        <ScrollRestoration />
        <Scripts />
        <LiveReload />
      </body>
    </html>
  );
};
